// Les deux badges de téléchargement, avec les liens des fiches App Store et Google Play.
import React from "react";
import appstore from "../images/appstore.svg";
import playstore from "../images/playstore.png";

export const LIEN_APP_STORE = "https://apps.apple.com/fr/app/gymnote-suivi-muscu-coach/id6470710692";
export const LIEN_GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.frenchmatrix.GymNote";

export default function BoutonsStores({ className = "" }) {
	return (
		<div className={`gs-stores ${className}`.trim()}>
			<a className="gs-store" href={LIEN_APP_STORE} target="_blank" rel="noopener noreferrer">
				<img src={appstore} alt="Télécharger dans l'App Store" />
			</a>
			<a className="gs-store" href={LIEN_GOOGLE_PLAY} target="_blank" rel="noopener noreferrer">
				<img src={playstore} alt="Disponible sur Google Play" />
			</a>
		</div>
	);
}
